import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["itemTab", "selectedItem"]

  selectedTabKey = ""

  connect() {
    if (this.element.dataset.selectedKey){
      this.selectedTabKey = this.element.dataset.selectedKey
    }

    this.markItemsAsActive()
  }

  selectTab(e){
    const { target: { dataset: { key, href, turboFrame } } } = e

    if (href){
      const options = {}
      if (turboFrame){
        options.frame = turboFrame
        options.action = 'replace'
      }

      Turbo.visit(href, options)

      return
    }

    this.selectedTabKey = key

    this.markItemsAsActive()
  }

  markItemsAsActive(){
    // Tabs
    this.itemTabTargets.forEach((itemTab) => {
      // Mark tab as active if it matches selectedTabKey
      itemTab.dataset.selected = itemTab.dataset.key === this.selectedTabKey
    })

    // Selected Item
    this.selectedItemTargets.forEach((item) => {
      item.dataset.selected = item.dataset.key === this.selectedTabKey
    })
  }
}
